import React, { PropsWithChildren } from 'react'
import { observer } from 'mobx-react-lite'
import { Navigate } from 'react-router-dom'

import { useStores } from '../stores/hooks'

export const GuestGuard: React.FC<PropsWithChildren> = observer(({ children }) => {
  const { authStore } = useStores()

  if (authStore.isLoggedIn) {
    return <Navigate to='/dashboard' />
  }

  return <>{children}</>
})
